import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const LinedCheck: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#666' }) => {
  return (
    /*@ts-ignore*/
    <svg viewBox="0 0 16 16" width={width} height={height} fill="none">
      <path
        fill={fill}
        fill-rule="evenodd"
        d="M6.862 10.471l-2-2c-.26-.26-.26-.682 0-.942.26-.26.682-.26.943 0l1.293 1.293c.13.13.34.13.47 0l3.294-3.293c.26-.26.682-.26.943 0 .26.26.26.682 0 .942l-4 4c-.13.13-.301.196-.472.196-.17 0-.341-.065-.471-.196zM8 14.667c-3.682 0-6.667-2.985-6.667-6.667S4.318 1.333 8 1.333 14.667 4.318 14.667 8 11.682 14.667 8 14.667zm0-1.334c2.945 0 5.333-2.387 5.333-5.333 0-2.945-2.388-5.333-5.333-5.333-2.946 0-5.333 2.388-5.333 5.333 0 2.946 2.387 5.333 5.333 5.333z"
        clip-rule="evenodd"
      />
    </svg>
  );
};

export default LinedCheck;
